import { useSetHeaderTitle } from 'shared/hooks/useSetHeader';
import OpportunitiesStateProvider from './context/OpportunitiesStateProvider';
import { OpportunitiesCont } from './Opportunities.styles';
import OpportunitiesTab from './components/OpportunitiesTab/OpportunitiesTab';
import React from 'react';

const Opportunities = () => {
  useSetHeaderTitle(`Opportunities`);

  // console.log('Opportunities Rendered');
  return (
    <OpportunitiesStateProvider>
      <OpportunitiesCont>
        <OpportunitiesTab />
      </OpportunitiesCont>
    </OpportunitiesStateProvider>
  );
};

export default React.memo(Opportunities);
